import {t} from '../../services/localization/localizationService';
import {twx} from '../../utils/tailwindUtils';

// text-[14px], not text-14: twx reads text-14 as a colour and drops it next to text-[#FFFDFB]
const AiAssistantWidgetText = ({strCode, isBold, className}) => (
    <span className={twx('text-[14px] leading-5 text-[#FFFDFB]', isBold && 'font-bold', className)}>{t(strCode)}</span>
);

export default AiAssistantWidgetText;
